module.exports = __webpack_public_path__ + "static/img/planocard.6b671115.jpeg";